<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Money Guided Admin Home</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<div class="row">
			<div class="col-md-2"></div>
			<div class="col-md-8">
				<div class="m-5 mt-0" style="text-align:center">
					<h2>Hi</h2>
					<p>You are logged in as {{email}}</p>
					<p>Choose what you would like to do from the top menu</p>
					<img height="300px" src="img/WomanMGChill.svg" style="position:fixed; bottom: 0px; left: 50%" /><br/><br/>
					<small><i>This is Peg. Peg says "Hi".  <br/>She will now read your fortune... please wait...</i></small>
				</div>
			</div>
			<div class="col-md-2"></div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Home',
  data() {
	return{
		email: null
	}
  },
  methods: {
	onLoad() {
		var t = this.parseJwt(this.$http.defaults.headers.common["Authorization"].split(' ')[1]);
		this.email = t.email;
	},
	parseJwt: function(token) {
		var base64Url = token.split('.')[1];
		var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		var jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
		return JSON.parse(jsonPayload);
	},
  },
  mounted: function() { this.onLoad(); }
}
</script>